const homepage = () => {
    if ($(".homepage").length) {
        affixSection();
        slideService();
        slideDoctor();
        slideEquipment();
        handleSection();
    }
    anchorForm();
}
const affixSection = () => {
    $(window).on('scroll', function (event) {
        if ($(window).width() < 1024) return;
        const scrollValue = $(window).scrollTop();

        if ($(window).height() - $(".header-menu").height() - 75 <= scrollValue) {
            if (!$('.homepage-section').hasClass('fixed-top')) {
                $('.homepage-section').addClass('fixed-top');
                $('.scrollable').addClass('p-95');
            }
        }
        else if ($('.homepage-section').hasClass('fixed-top')) {
            $('.homepage-section').removeClass('fixed-top');
            $('.scrollable').removeClass('p-95');
        }
    });

}

document.addEventListener('scroll', affixSection, {passive: true});

const slideService = () => {
    let slickInstance = $(".home-service-slick").slick({
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        adaptiveHeight: true,
        centerMode: true,
        vertical: true,
        verticalSwiping: false,
        arrows: false,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    autoplay: false,
                    vertical: false,
                    verticalSwiping: false,
                    centerMode: false,
                    arrows: false,
                }
            },
        ]
    })

    $(".homepage-service .service-slick-title").on("click", ".title-item", function () {

        const $parent = $(this).parent(".service-slick-title");
        $parent.find(".active").removeClass("active");
        $(this).addClass("active")

        const index = $(this).index()
        slickInstance.slick('slickGoTo', index);

    })
}

const slideDoctor = () => {
    $(".home-doctor-slick").slick({
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        adaptiveHeight: true,
        centerMode: false,
        autoplay: true,
        autoplaySpeed: 5000,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerMode: true,
                    arrows: false,
                    dots: true
                }
            },
        ]
    })
}

const slideEquipment = () => {
    $(".home-equipment-slick").slick({
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        adaptiveHeight: true,
        centerMode: true,
        autoplay: true,
        autoplaySpeed: 5000,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerMode: true,
                    arrows: false,
                    dots: false
                }
            },
        ]
    })
}

const handleSection = () => {
    $(".homepage-section").on('click', '.item', function () {
        const $parent = $(this).parents(".homepage-section");
        const goto = $(this).data("goto")
        const index = $(this).index()

        //$('html, body').scrollTop($(goto).offset().top - 200)
        $('html, body').animate({
            scrollTop: $(goto).offset().top - 200
          }, 800);
    })
    $(window).on('scroll', function () {
        if ($(window).width() < 1024) return;

        $(".homepage-section .item").each(function (e) {

            const $parent = $(this).parents(".homepage-section")
            const goto = $(this).data("goto")
            const start = $(goto).offset()?.top || 0;
            const end = start + $(goto).height();
            const currentScroll = $(window).scrollTop() + 200;

            if (currentScroll > start && currentScroll < end) {
                if (!$(this).hasClass('active')) {
                    $parent.find(".item.active").removeClass("active")
                    $(this).addClass("active")
                }
            }
            else if ($(this).hasClass("active")) {
                $(this).removeClass("active")
            }
        })
    })
}

const anchorForm = () => {
    $(".template-14").on("click", "#join-forum", function () {
        $('html,body').animate({
            scrollTop: $('#register-forum').offset().top - 80
        }, 800);
    })
}


module.exports = homepage
